import InvalidRoute from './invalid-route';
export default InvalidRoute;
